
import { defineComponent, ref } from "vue";
import { geometry } from "@turf/helpers";
import { useLocation } from "@/services";
import { CoordinateLocation } from "@/types/location/CoordinateLocation";
import CoordinatesInput from "@/components/shared/CoordinatesInput.vue";
export default defineComponent({
  name: "CoordinateSearch",
  components: { CoordinatesInput },
  setup(_, { emit }) {
    const coords = ref({
      lat: null,
      lng: null,
    });
    const search = () => {
      if ([coords.value.lat, coords.value.lng].some((o) => !o)) {
        return;
      }
      const coordinate = {
        type: "Coordinate",
        geometry: geometry("Point", [coords.value.lng, coords.value.lat]),
      } as CoordinateLocation;
      useLocation().updateLocation(coordinate);
      emit("addressFound", coordinate);
    };
    const test = ref<string>("123321/43243");

    return {
      search,
      test,
      coords,
    };
  },
});
